<template>
    <text-dialog :title="title">
        <slot name="activator" slot="activator"></slot>

        <div slot="content" style="text-align: center;">
            <iframe width="560" height="315" :src="videoSource" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
    </text-dialog>
</template>

<script>
    import TextDialog from '../dialogs/TextDialog';

    export default {
        components: {
            TextDialog
        },
        props: {
            title: {
                type: String,
                required: true
            },
            videoSource: {
                type: String,
                required: true
            }
        }
    }
</script>